<template>
    <f-dialog
        v-if       = "inspection"
        :title     = "$t('disposition.inspection.tooltip.assign')"
        v-model    = "value"
        :width     = "460"
        storeLabel = "Zuordnen"
        :show-save = "!!unit"
        @cancel    = "onCancel"
        @store     = "onAssign"
    >
        <template v-slot:toolbar>
            <c-toolbar-button
                v-if     = "unit"
                color    = "white"
                size     = "24"
                icon     = "mdi-magnify"
                :tooltip = "$t('disposition.inspection.tooltip.search')"
                @click   = "unit = null"
                class    = "mr-1"
            />
        </template>
        <template v-slot:content>
            <c-site-select-single
                v-if       = "!unit"
                :customer  = "inspection.order.customer"
                :all-units = "true"
                @site      = "onSite"
            />
            <div v-if="unit">
                <v-row dense class="mt-1">
                    <v-col>
                        <f-read-only-field
                            :label = "$t('disposition.inspection.hcid')"
                            class  = "pr-2"
                            :value = "unit.id"
                            filled
                            frame
                            dense
                        />
                    </v-col>
                    <v-col>
                        <f-read-only-field
                            :label = "$t('disposition.inspection.no')"
                            class  = "pr-2"
                            :value = "unit.fabricNo"
                            filled
                            frame
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <f-read-only-field
                            :label = "$t('disposition.inspection.zip')"
                            class  = "pr-2"
                            :value = "zip"
                            filled
                            frame
                            dense
                        />
                    </v-col>
                    <v-col>
                        <f-read-only-field
                            :label = "$t('disposition.inspection.city')"
                            class  = "pr-2"
                            :value = "unit.city"
                            filled
                            frame
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <f-read-only-field
                            :label = "$t('disposition.inspection.street')"
                            class  = "pr-2"
                            :value = "unit.street"
                            filled
                            frame
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <f-read-only-field
                            :label = "$t('disposition.unit.ve')"
                            class  = "pr-2"
                            :value = "unit.ve"
                            filled
                            frame
                            dense
                        />
                    </v-col>
                    <v-col>
                        <f-read-only-field
                            :label = "$t('disposition.unit.ve2')"
                            class  = "pr-2"
                            :value = "unit.ve2"
                            filled
                            frame
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row dense class="mb-3">
                    <v-col>
                        <f-read-only-field
                            :label = "$t('disposition.unit.ve3')"
                            class  = "pr-2"
                            :value = "unit.ve3"
                            filled
                            frame
                            dense
                        />
                    </v-col>
                </v-row>
            </div>
        </template>
    </f-dialog>
</template>

<script>

import CSiteSelectSingle from "@/modules/msd/unit/components/controlls/CSiteSelectSingle";
import FDialog           from "@/modules/core/components/utils/FDialog";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import Core from "@/modules/core/service/Core";
import Disposition from "@/modules/dis/service/Disposition";

export default {
    name: "DInspectionAssignUnit",

    components: {
        CToolbarButton,
        FReadOnlyField,
        FDialog,
        CSiteSelectSingle,
    },

    props: {
        value: {

        },

        inspection: {

        }
    },

    data: () => ({
        show    : false,
        customer: null,
        unit    : null
    }),

    computed: {
        zip () {
            if (!this.unit) {
                return null;
            }

            return this.unit.country.iso3166 + "-" + this.unit.zip;
        }
    },

    watch: {
        value () {
            this.show = this.value;
            this.customer = null;
            this.unit = null;
        },
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        onAssign () {
            Core.message.confirm(
                this,
                this.$t('disposition.unit.assign.query'),
                this.$t('disposition.unit.assign.text'),
                Core.message.Default,
                (value) => {
                    if (value) {
                        Disposition.inspection.assignUnit(this.inspection, this.unit).then(inspection => {
                            this.$emit("input", false);
                            this.$emit("assigned", inspection)
                        }).catch(error => {
                            if (!error.id) {
                                this.$emit("input", false);
                                return;
                            }
                            Core.message.popup(this, error.id, error.parameter);
                        })
                    }
                })
        },

        onSite (unit) {
            this.unit = unit;
        },
    }
}
</script>

<style scoped>

</style>